module.exports = __webpack_public_path__ + "img/out.812f84e3.svg";